module.exports = __webpack_public_path__ + "static/media/background-desktop-login.fbcda6b3.svg";